import { initI18n } from '@repo/shared/i18n';

import en from './locales/en/zoom.json';
import es from './locales/es/zoom.json';
import hi from './locales/hi/zoom.json';
import ar from './locales/ar/zoom.json';

export default initI18n('zoom', { en, es, hi, ar });
